import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import '../../CSS/Advanced.css'; 
import Prism from 'prismjs';
import 'prismjs/themes/prism.css'; 
import 'prismjs/components/prism-javascript.min.js'; 
import 'prismjs/components/prism-css.min.js'; 
import 'prismjs/components/prism-markup.min.js'; 

import html from '../../images/component/html.png';
import javascript from '../../images/component/javaScript.png';
import css from '../../images/component/css.png';

// import AdvancedBlog from './AdvancedBlog';

const Advanced = () => {
  const { category } = useParams(); // Extract category from URL
  const navigate = useNavigate();

  const [animations, setAnimations] = useState([]);
  const [selectedAnimation, setSelectedAnimation] = useState(null);
  const [activeTab, setActiveTab] = useState('html'); 
  const [selectedCategory, setSelectedCategory] = useState(category || 'all'); // Set initial category from URL or default to 'all'

  const categories = [
    'all', 'footer', 'paragraph','button', 'dropdown', 'text', 'layout', 'background', 
    'toggle', 'radio', 'slider', 'loading', 'table', 'menu', 'card'
  ];

  useEffect(() => {
    // Load animations from the JSON file
    fetch('/animations/advancedAnimations.json')
      .then((response) => response.json())
      .then((data) => setAnimations(data))
      .catch((error) => console.error('Error loading animations:', error));
  }, []);

  useEffect(() => {
    // Automatically select the first animation in the filtered list when the category changes
    const filtered = filterAnimations();
    if (filtered.length > 0) {
      setSelectedAnimation(filtered[0]);
    } else {
      setSelectedAnimation(null); // Clear selection if no animations match the category
    }
  }, [selectedCategory, animations]);

  useEffect(() => {
    Prism.highlightAll(); // Apply syntax highlighting
  }, [selectedAnimation, activeTab]);

  useEffect(() => {
    // Update the selected category when the URL changes
    if (category && category !== selectedCategory) {
      setSelectedCategory(category); // Update the selected category based on the URL
    }
  }, [category, selectedCategory]);

  useEffect(() => {
    // When an animation is selected, inject the CSS and execute the JS
    if (selectedAnimation) {
      injectCSS(selectedAnimation.css);
      executeJS(selectedAnimation.js);
    }
  }, [selectedAnimation]);




  const filterAnimations = () => {
    return animations.filter((animation) => {
      const category = categorizeAnimation(animation);
      if (selectedCategory === 'all') return true;
      return category === selectedCategory;
    });
  };

  const categorizeAnimation = (animation) => {
    const categories = ['footer', 'paragraph','button','text', 'background', 'toggle', 'slider', 'table', 'card', 'loading', 'menu', 'dropdown', 'radio', 'layout'];
    const matchCategory = categories.find(category => animation.name.toLowerCase().includes(category));
    return matchCategory;
  };

  const formatText = (text) => {
    return text
      .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
      .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
      .replace(/_/g, ' ')
      .toLowerCase()
      .replace(/^\w/, (c) => c.toUpperCase());
  };

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    navigate(`/advanced/${category}`); // Navigate to the new category URL
  };

  // Handle clicking on an animation to display it in the box
  const handleAnimationClick = (animation) => {
    setSelectedAnimation(animation);
  };

  const injectCSS = (css) => {
    const styleElement = document.createElement('style');
    styleElement.innerHTML = css;
    document.head.appendChild(styleElement);
  };

  const executeJS = (js) => {
    try {
      new Function(js)();
    } catch (e) {
      console.error('Error executing JS:', e);
    }
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };



  return (
    <div className="advanced-container">
      <h2>Pre-Built Components</h2>
	  <h3 id='componentDesc'>Pick from a wide array of pre-built components to integrate into your website directly! </h3>

      {/* Category Filter */}
      <div className="category-filter">
        {categories.map((category) => (
          <label
            key={category}
            className={selectedCategory === category ? 'selected' : ''}
          >
            <input
              type="radio"
              name="category"
              value={category}
              checked={selectedCategory === category}
              onChange={() => handleCategoryChange(category)}
            />
            {category.charAt(0).toUpperCase() + category.slice(1)}
          </label>
        ))}
      </div>

      {/* List of animations (filtered based on selected category) */}
	  	<div id='animation-list-and-display'>

      <div className="animations-list">
        {filterAnimations().map((animation, index) => (
          <div
            key={index}
            className={`animation-item ${selectedAnimation === animation ? 'selected' : ''}`}
            onClick={() => handleAnimationClick(animation)}
          >
            <h3>{formatText(animation.name)}</h3>
          </div>
        ))}
      </div>

			{/* Display the selected animation */}
			{selectedAnimation && (
				<div className="animation-box">
				<div id="animation-code">
				<h3 className="animationName">{formatText(selectedAnimation.name)}</h3>
					<p className="animationDesc">{selectedAnimation.description}</p>

					{/* Tab toggle buttons using images */}
					<div className="tab-toggle">
					<button onClick={() => handleTabChange('html')} className={activeTab === 'html' ? 'active' : ''}>
						<img src={html} alt="HTML" />
					</button>
					<button onClick={() => handleTabChange('css')} className={activeTab === 'css' ? 'active' : ''}>
						<img src={css} alt="CSS" />
					</button>
					{selectedAnimation.js && selectedAnimation.js !== '' && (
					<button onClick={() => handleTabChange('js')} className={activeTab === 'js' ? 'active' : ''}>
						<img src={javascript} alt="JavaScript" />
					</button>
					)}

					</div>

					{/* HTML Preview */}
					{activeTab === 'html' && (
					<div className="html-preview">
						<pre className='pre-box'>
						<code className="language-markup">{selectedAnimation.html}</code>
						</pre>
					</div>
					)}

					{/* CSS Preview */}
					{activeTab === 'css' && (
					<div className="css-preview">
						<pre className='pre-box'>
						<code className="language-css">{selectedAnimation.css}</code>
						</pre>
					</div>
					)}

					{/* JS Preview */}
					{activeTab === 'js' && (
					<div className="js-preview">
						<pre className='pre-box'>
						<code className="language-javascript">{selectedAnimation.js}</code>
						</pre>
					</div>
					)}
				</div>

				<div
					className="animation-render-box"
					dangerouslySetInnerHTML={{
					__html: selectedAnimation.html,
					}}
				/>
				</div>
			)}
		</div>

    </div>
  );
};

export default Advanced;
